<template>
<div class="vx-row w-full mb-3 mt-2" style="align-items: center; padding-left: 28px;">
    Du
				<vx-input-group class="datepicker-1 vx-col">
				
					<flat-pickr
						id="flatpickr"
						v-model="startDate"
						:config="configPeriodPicker"
						style="width: 100px; text-align: center;"
					
					/>
				</vx-input-group>
                Au
				<vx-input-group class="datepicker-1 vx-col">
				
					<flat-pickr
						id="flatpickr"
						v-model="endDate"
						:config="configPeriodPicker"
						style="width: 100px; text-align: center;"
					/>
				</vx-input-group>
                <div class="vx-row w-full" style="align-items: center; padding-left: 28px;">
				<vs-button class="mt-2 w-full" @click="generate()">Confirmer</vs-button>
			</div>
</div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import VueCookies from "vue-cookies";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
export default {
	components: {
		flatPickr
	},
	name: "ReportFilterMission",
	mixins: [],
	data() {
		return {
            apiUrl: this.$store.state.backendApiUrl,
            startDate: null,
            endDate: null,
			configPeriodPicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light"
					})
				],
			},
		};
	},
	created() {
		//console.log("messsage");
	},
	mounted() {
	

	},
	computed: {
        activeUser: () => {
			return VueCookies.get("userInfo");
		},
	},
	watch: {

	},

	methods: {
		generate(){
            this.$emit('close-popup');
            let edate = !this.endDate?null:this.endDate.split("/").reverse().join("-");
			let sdate = !this.startDate?null:this.startDate.split("/").reverse().join("-");
			let request = "report/extractPrestation";
			this.$http.post(this.apiUrl + request, {
				end_date: edate? edate: null,
				report_id: 4,
				start_date: sdate ? sdate : null,
				user_id: this.activeUser.id,
				user_email: this.activeUser.email,
			});
		},
	}
};
</script>

<style>
.center {
  justify-content: center;
}
</style>
